var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoList01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40.8 40.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.8,
    height: 40.8,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 40.8,
    height: 40.8,
    rx: 8,
    ry: 8,
    fill: "#f2642a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.14,9.6059c-.257,0-.466.209-.466.466v20.656c0,.257.209.466.466.466h16.52c.257,0,.466-.209.466-.466V10.0719c0-.257-.209-.466-.466-.466H12.14Zm16.52,22.843H12.14c-.949,0-1.721-.772-1.721-1.721V10.0719c0-.949.772-1.721,1.721-1.721h16.52c.949,0,1.721.772,1.721,1.721v20.656c0,.949-.772,1.721-1.721,1.721",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.7677,16.2204h-.021c-.195-.007-.376-.104-.49-.263l-.642-.899c-.201-.282-.136-.674.146-.875s.674-.136.875.146l.167.233,1.087-1.323c.219-.268.615-.307.883-.087.267.22.306.616.086.883l-1.606,1.956c-.12.145-.298.229-.485.229",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.6745,15.6032h-5.793c-.346,0-.627-.281-.627-.627,0-.347.281-.628.627-.628h5.793c.346,0,.627.281.627.628,0,.346-.281.627-.627.627",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.7677,22.0051h-.021c-.195-.007-.376-.104-.49-.263l-.642-.899c-.201-.282-.136-.674.146-.875s.674-.136.875.146l.167.233,1.087-1.323c.219-.268.615-.307.883-.087.267.22.306.616.086.883l-1.606,1.956c-.12.145-.298.229-.485.229",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.6745,21.3879h-5.793c-.346,0-.627-.281-.627-.627,0-.347.281-.628.627-.628h5.793c.346,0,.627.281.627.628,0,.346-.281.627-.627.627",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.7677,27.7899h-.021c-.195-.007-.376-.104-.49-.263l-.642-.899c-.201-.282-.136-.674.146-.875s.674-.136.875.146l.167.233,1.087-1.323c.219-.268.615-.307.883-.087.267.22.306.616.086.883l-1.606,1.956c-.12.145-.298.229-.485.229",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.6745,27.1726h-5.793c-.346,0-.627-.281-.627-.627,0-.347.281-.628.627-.628h5.793c.346,0,.627.281.627.628,0,.346-.281.627-.627.627",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoList01);
export default __webpack_public_path__ + "static/media/ico-list-01.263cb6f439d5f1a8ff7cc2888f6d22d1.svg";
export { ForwardRef as ReactComponent };